import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    newestOnTop: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};

export const successAlert = ({ message = "Successful" }) => {
    toast.success(message, toastConfig);
};

export const errorAlert = ({ message = "Something went wrong" }) => {
    toast.error(message, toastConfig);
};

export const warningAlert = ({ message = "Warning", }) => {
    toast.warning(message, toastConfig);
};

export const infoAlert = ({ message = "Information" }) => {
    toast.info(message, toastConfig);
};

export const AlertContainer = () => {
    return <ToastContainer theme="colored" />;
};